import {
	IFanVoteSavedModal,
	IModalReducer,
	IReducerAction,
	IShowFieldDetailsModal,
	ITeam,
	Nullable,
} from "modules/types";
import {createReducer} from "redux-act";
import {
	closeDontLoseTeamModal,
	closeFanVoteSavedModal,
	closeSSOAdditionalFieldsModal,
	closePlayerDetailsModal,
	openDontLoseTeamModal,
	openFanVoteSavedModal,
	openSSOAdditionalFieldsModal,
	openPlayerDetailsModal,
	toggleErrorModal,
	toggleSuccessModal,
	openConfirmPicksModal,
	closeConfirmPicksModal,
} from "modules/actions";
import {DetailsModalTabs} from "modules/enums";

const initialState: IModalReducer = {
	errorModal: {
		message: null,
	},
	playerModal: {
		playerId: null,
	},
	isLeaveModalVisible: false,
	successModalData: null,
	isOpenSSOAdditionalFieldsModal: false,
	isOpenDontLoseTeamModal: false,
	fanVoteSavedModal: null,
	isOpenConfirmPicksModal: false,
};

type IModalReducerPayload<TP = null> = IReducerAction<IModalReducer, TP>;

const onToggleErrorModal: IModalReducerPayload<Nullable<string>> = (state, payload) => ({
	...state,
	errorModal: {
		message: payload,
	},
});

const onToggleSuccessModal: IModalReducerPayload<Nullable<ITeam>> = (state, payload) => ({
	...state,
	successModalData: payload,
});

const onOpenSSOAdditionalFieldsModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenSSOAdditionalFieldsModal: true,
});

const onCloseSSOAdditionalFieldsModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenSSOAdditionalFieldsModal: false,
});

const onOpenDontLoseTeamModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenDontLoseTeamModal: true,
});

const onCloseDontLoseTeamModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenDontLoseTeamModal: false,
});

const onShowPlayerDetailsModal: IModalReducerPayload<IShowFieldDetailsModal> = (
	state,
	payload
) => ({
	...state,
	playerDetailsModal: {
		...payload,
		tab: payload.tab || DetailsModalTabs.Overview,
	},
});

const onHidePlayerDetailsModal: IModalReducerPayload = (state) => ({
	...state,
	playerDetailsModal: undefined,
});

const onOpenFanVoteSavedModal: IModalReducerPayload<IFanVoteSavedModal> = (state, payload) => ({
	...state,
	fanVoteSavedModal: payload,
});

const onCloseFanVoteSavedModal: IModalReducerPayload = (state) => ({
	...state,
	fanVoteSavedModal: null,
});

const onOpenConfirmPicksModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenConfirmPicksModal: true,
});

const onCloseConfirmPicksModal: IModalReducerPayload = (state) => ({
	...state,
	isOpenConfirmPicksModal: false,
});

export const modalReducer = createReducer<IModalReducer>({}, initialState)
	.on(toggleErrorModal, onToggleErrorModal)
	.on(toggleSuccessModal, onToggleSuccessModal)
	.on(openSSOAdditionalFieldsModal, onOpenSSOAdditionalFieldsModal)
	.on(closeSSOAdditionalFieldsModal, onCloseSSOAdditionalFieldsModal)
	.on(openDontLoseTeamModal, onOpenDontLoseTeamModal)
	.on(closeDontLoseTeamModal, onCloseDontLoseTeamModal)
	.on(openPlayerDetailsModal, onShowPlayerDetailsModal)
	.on(closePlayerDetailsModal, onHidePlayerDetailsModal)
	.on(openFanVoteSavedModal, onOpenFanVoteSavedModal)
	.on(closeFanVoteSavedModal, onCloseFanVoteSavedModal)
	.on(openConfirmPicksModal, onOpenConfirmPicksModal)
	.on(closeConfirmPicksModal, onCloseConfirmPicksModal);
